import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';

export const StyledCard = styled(Card)(() => ({
  borderRadius: 4,
  boxShadow: 2,
  mb: 2,
  overflow: 'hidden',

  '& .MuiCardContent-root': {
    padding: '16px',
    '&:last-child': {
      paddingBottom: '16px',
    },
  },
}));